import script from "./marketingSend.vue?vue&type=script&setup=true&lang=ts"
export * from "./marketingSend.vue?vue&type=script&setup=true&lang=ts"

import "./marketingSend.vue?vue&type=style&index=0&id=67e9d8a5&lang=css"

const __exports__ = script;

export default __exports__